import { Record } from 'immutable';
import _ from 'lodash';

const properties = {
  id: '',
  isGlobal: false,
  name: '',
  code: '',
  privileges: [],
  assignable: false,
};

export default class Role extends Record(properties, 'Role') {
  public readonly id!: string;

  public readonly isGlobal!: boolean;

  public readonly privileges!: string[];

  public readonly name!: string;

  public readonly code!: string;

  public readonly assignable!: boolean;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      isGlobal: !values.organization,
    });
  }
}
